export default {
  SERVICE_LINK: {
    ATCOSME: {
      PC: {
        URL: process.env.SERVICE_LINK.ATCOSME.PC.URL,
      },
      SP: {
        URL: process.env.SERVICE_LINK.ATCOSME.SP.URL,
      },
      TOP: {
        URL: process.env.SERVICE_LINK.ATCOSME.TOP.URL,
      },
      PREMIUM: {
        REGISTER: {
          PC: {
            URL: process.env.SERVICE_LINK.ATCOSME.PREMIUM.REGISTER.PC.URL,
          },
          SP: {
            URL: process.env.SERVICE_LINK.ATCOSME.PREMIUM.REGISTER.SP.URL,
          },
        },
        CANCEL: {
          SP: {
            URL: process.env.SERVICE_LINK.ATCOSME.PREMIUM.CANCEL.SP.URL,
          },
        },
      },
      SITEMAP: {
        PC: {
          URL: process.env.SERVICE_LINK.ATCOSME.SITEMAP.PC.URL,
        },
      },
      SERVICE_LIST: {
        SP: {
          URL: process.env.SERVICE_LINK.ATCOSME.SERVICE_LIST.SP.URL,
        },
      },
      HELP: {
        PC: {
          URL: process.env.SERVICE_LINK.ATCOSME.HELP.PC.URL,
        },
        SP: {
          URL: process.env.SERVICE_LINK.ATCOSME.HELP.SP.URL,
        },
      },
      CONTACT: {
        PC: {
          URL: process.env.SERVICE_LINK.ATCOSME.CONTACT.PC.URL,
        },
        SP: {
          URL: process.env.SERVICE_LINK.ATCOSME.CONTACT.SP.URL,
        },
      },
      CS_BLOG: {
        URL: process.env.SERVICE_LINK.ATCOSME.CS_BLOG.URL,
      },
      SATISFACTION_ENQUETE: {
        URL: process.env.SERVICE_LINK.ATCOSME.SATISFACTION_ENQUETE.URL,
      },
      TERMS_AND_GUIDELINES: {
        SP: {
          URL: process.env.SERVICE_LINK.ATCOSME.TERMS_AND_GUIDELINES.SP.URL,
        },
      },
      SEARCH: {
        SP: {
          URL: process.env.SERVICE_LINK.ATCOSME.SEARCH.SP.URL,
        },
      },
      USER: {
        URL: process.env.SERVICE_LINK.ATCOSME.USER.URL,
      },
      POINT: {
        URL: process.env.SERVICE_LINK.ATCOSME.POINT.URL,
        USER: {
          URL: process.env.SERVICE_LINK.ATCOSME.POINT.USER.URL,
        },
        COUPON: {
          URL: process.env.SERVICE_LINK.ATCOSME.POINT.COUPON.URL,
        },
      },
      Q_AND_A: {
        URL: process.env.SERVICE_LINK.ATCOSME.Q_AND_A.URL,
      },
      RANKING: {
        URL: process.env.SERVICE_LINK.ATCOSME.RANKING.URL,
      },
      BEST_COSME: {
        PC: {
          URL: process.env.SERVICE_LINK.ATCOSME.BEST_COSME.PC.URL,
        },
        SP: {
          URL: process.env.SERVICE_LINK.ATCOSME.BEST_COSME.SP.URL,
        },
      },
    },
    AUTH: {
      ACCOUNT: {
        URL: process.env.SERVICE_LINK.AUTH.ACCOUNT.URL,
      },
    },
    COMPANY: {
      URL: process.env.SERVICE_LINK.COMPANY.URL,
    },
    TERMS_OF_SERVICE: {
      URL: process.env.SERVICE_LINK.TERMS_OF_SERVICE.PC.URL,
    },
    PRIVACY: {
      URL: process.env.SERVICE_LINK.PRIVACY.PC.URL,
    },
    PRIVACY_POLICY: {
      PC: {
        URL: process.env.SERVICE_LINK.PRIVACY_POLICY.PC.URL,
      },
      SP: {
        URL: process.env.SERVICE_LINK.PRIVACY_POLICY.SP.URL,
      }
    },
    COPYRIGHT: {
      URL: process.env.SERVICE_LINK.COPYRIGHT.PC.URL,
    },
    DECLARATION: {
      URL: process.env.SERVICE_LINK.DECLARATION.PC.URL,
    },
    COOKIE: {
      PC: {
        URL: process.env.SERVICE_LINK.COOKIE.PC.URL,
      }
    }
  },
  ACTION_API: {
    URL_BASE: {
      GLOBAL: process.env.ACTION_API.URL_BASE.GLOBAL,
    },
  },
  PLATFORM_API: {
    URL_BASE: {
      EXTERNAL: process.env.PLATFORM_API.URL_BASE.EXTERNAL,
    },
  },
  SMALL_LIGHT_HOST: process.env.SMALL_LIGHT_HOST,
  IPFEED_API_ENDPOINT: process.env.IPFEED_API_ENDPOINT,
  TRACKINGHATCH_ENDPOINT: process.env.TRACKINGHATCH_ENDPOINT,
  GLOBAL_FEED_NOIMAGE: '//s.cosme.net/images/spn/top/noimg_top.png',
  SPACER_IMAGE_URL: process.env.SPACER_IMAGE_URL,
  FLEX_ONE_HARRIER_PARAMATER: {
    3 : {
      id  : "feed-ad01",
      ad_slot_id:6186,
    },
    6 : {
      id  : "feed-ad02",
      ad_slot_id:6187,
    },
    7 : { // 純広告
      id  : "feed-adp01",
      ad_slot_id:6188,
    },
    10: { // 純広告
      id  : "feed-adp02",
      ad_slot_id:6189,
    },
    13: {
      id  : "feed-ad03",
      ad_slot_id:6190,
    },
    17: {
      id  : "feed-ad04",
      ad_slot_id:6191,
    },
    21: {
      id  : "feed-ad05",
      ad_slot_id:7360,
    },
  },
  WALLET_API : {
    URL_BASE: {
      GLOBAL: process.env.WALLET_API.URL_BASE.GLOBAL,
    },
  },
  BEAUTIST_URL: process.env.BEAUTIST_URL,
  SHOP: {
    URL_BASE: {
      PC: process.env.SHOP.URL_BASE.PC,
    },
  },
  AT_COSME_TOKYO : {
    HARAJUKU: {
      SPECIAL_URL: process.env.AT_COSME_TOKYO.HARAJUKU.SPECIAL_URL
    }
  },
  ATCOSME_SHOPPING_URL: 'https://www.cosme.com/',
  BICHE_URL: 'https://www.cosme.net/biche/',
  CAREER_URL: 'https://career.cosme.net/',
  SATISFACTION_ENQUETE_URL: 'https://is-enq.cosme.net/app/usr/ans/privacy_pc.php?kind=is&enq_id=7453&a_key=1mlr0WGW2tnwHOGkHmfpTNw.1yCkT5nH',
  COMPANY_URL: 'https://www.istyle.co.jp/',
  TWITTER_URL: 'https://twitter.com/atcosmenet',
  FACEBOOK_URL: 'https://www.facebook.com/atcosme/',
  LINE_URL: 'https://line.me/R/ti/p/%40at_cosme',
  BEAUTYDAY_URL: 'https://www.cosme.com/campaign/beautyday/',
  RANKING_INFO_URL: 'https://www.cosme.net/html/sng/review/',
  BUSINESS_URL: 'https://business.cosme.net/',
  MICAEL_URL: 'https://www.cosme.net/html/spc/about-micael/',
  UID_WEB_GATEWAY_API: {
    URL_BASE: process.env.UID_WEB_GATEWAY_API.URL_BASE,
  },
};
